export const UNSEEN_MESSAGES_COUNT_LOADED = 'UNSEEN_MESSAGES_COUNT_LOADED';

export const unseenMessagesCountLoaded = ( unseenMessagesCount ) => ( {
    type:  UNSEEN_MESSAGES_COUNT_LOADED,
    unseenMessagesCount
} );